<template>
  <div>
  <Breadcrumbs main="Services" title="Account Update" />
    <div class="container-fluid" v-if="details && userSecurityQuestion">
      <div class="row">
        <div class="col-xl-3 pr-sm-0 box-col-12">
          <div class="file-sidebar">
            <div class="card">
              <div class="card-body">
                <div class="text-center col-auto">
                    <!--<img class="img-fluid rounded-circle" v-if="imgsrc" width="150" :src="`data:image/png;base64,${profilePicture}`"> -->
                    <img class="rounded-circle" v-if="profilePicture" width="150" height="150" :src="`data:image/png;base64,${profilePicture}`">
                    <img class="rounded-circle" v-else width="150" height="150" :src="userImage"> <br>
                    <input type="file" accept="image/*" @change="uploadImage" style="display: none;" ref="fileInput" class="file-upload-default"> 
                    <div class="text-center d-flex justify-content-center mt-3">
                        <button @click="$refs.fileInput.click()" class="btn btn-primary btn-sm mt-2">
                          <div v-if="loadingImage">
                            <i class='fa fa-refresh fa-spin'></i>&nbsp;Uploading...
                          </div>
                          <div v-else>
                            Update Image
                          </div>
                        </button>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-9 col-md-12 box-col-12">
          <div class="file-content">
            <div class="card">
            <div v-if="loading" class="loader-12"></div>
              <div class="card-header">
                <h5 class="font-weight-normal">Account Update</h5>
                <span>Fill the form below to update your account.</span>
              </div>
              <div id="RequestFormSection" class="animated fadeIn" v-show="step === 1">
                  <div class="card-body">
                      <form class="theme-form is-validated" id="Submit_Transfer_Form">
                          <!-- Initiate the Transfer -->
                          <div id="InitiateTransfer">
                              <div class="mb-3 row">
                                  <label class="col-sm-3 col-form-label" for="AccountNumber">Email <span class="text-danger">*</span></label>
                                  <div class="col-sm-9 col-xl-7">
                                      <input type="email" class="form-control" v-model="userEmail" readonly  placeholder="Update Email" required>
                                      <button data-toggle="modal" data-target="#updateEmail" type="button" class="pull-right btn btn-primary text-white btn-sm mt-2">Change</button>
                                  </div>
                              </div>
                              <div class="mb-3 row">
                                  <label class="col-sm-3 col-form-label" for="location">Phone Number <span class="text-danger">*</span></label>
                                  <div class="col-sm-9 col-xl-7">
                                    <input class="form-control" readonly v-model="userPhoneNumber" placeholder="Update Number *" type="text"/>
                                    <button type="button" data-toggle="modal" data-target="#updatePhoneNumber" class="pull-right btn btn-primary text-white btn-sm mt-2">Change</button>
                                  </div>
                              </div>
                              <div class="mb-3 row">
                                <label class="col-sm-3 col-form-label">Address <span class="text-danger">*</span></label>
                                    <div class="col-sm-9 col-xl-7">
                                        <input class="form-control" readonly v-model="userAddress" placeholder="Update Address *" type="text" />
                                        <button type="button" data-toggle="modal" data-target="#updateAddress" class="pull-right btn btn-primary text-white btn-sm mt-2">Change</button>
                                    </div>
                              </div>
                          </div>
                      </form>
                  </div>
              </div>

              <!-- Request Success Response -->
              <div id="RequestSuccessResponseSection" v-show="step === 2" class="animated fadeIn" style="display:block; padding:40px 0">
                <div class="card-body">
                    <div class="align-content-center align-items-center justify-content-center p-2 text-center">
                        <img src="@/assets/TAJimages/notification/success.png" alt="Error Icon image" class="img-fluid" />
                        <h5 class="text-bold-700 mb-2 text-success"><i class="feather icon-check-circle fa-2x"></i> Account update logged successfully!</h5>
                        <p>We're happy to see you scale. Do much more with TAJBank.</p>
                        <router-link to="/dashboard/default">
                            <a class="btn btn-primary btn-round">Go To Home<i class="fa fa-home ml-2"></i></a>
                        </router-link>
                    </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal for email update -->
    <div class="modal fade" id="updateEmail" tabindex="-1" role="dialog" aria-labelledby="updateEmailCenter" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-centered modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title pl-2" id="updateEmailCenter" style="font-size: 18px">Change Email</h5>
                    <button class="close text-dark" type="button" @click="resetForm" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body p-4">
                  <div class="mb-3 row">
                      <label class="col-sm-12 col-form-label" for="AccountNumber">Email <span class="text-danger">*</span></label>
                      <div class="col-sm-12 col-xl-12">
                          <input type="email" v-model="form.email" class="form-control"  placeholder="Update Email" required>
                      </div>
                  </div>
                  <div class="mb-3 row">
                      <label class="col-sm-12 col-form-label" for="SecurityQuestion">Security Question<span class="text-danger">*</span></label>                             
                      <div class="col-sm-12 col-md-12">
                        <select class="form-control" placeholder="Select" v-model="form.securityQuestionId" id="SecurityQuestion" required>
                            <option value="" disabled>Select Security Question</option>
                            <option v-for="question in userSecurityQuestion" :value="question.id" :key="question.id">{{question.question}}</option>
                        </select>
                      </div>
                  </div>
                  <div class="row">
                      <label class="col-sm-12 col-form-label" for="SecurityAnswer">Security Answer <b class="text-danger">*</b></label>
                      <div class="col-sm-12 col-md-12">
                          <input class="form-control" @click="removeReadonly" id="no-paste" v-model="form.securityAnswer" placeholder="Enter Security Answer *" :type="answerType" />
                          <span @click="showAnswer" class="pull-right show-Password">{{ answerType === 'password' ? 'show' : 'hide'}}</span>
                      </div>
                  </div>
                  <div class="mb-3 row">
                    <label class="col-sm-12 col-form-label" for="Token">Transaction Pin <span class="text-danger">*</span></label>
                    <div class="col-sm-12 col-xl-12">
                        <input @keypress="isNumber" @paste.prevent class="form-control" min="0" v-model="form.transactionPin" pattern="\d*" maxlength="4"  placeholder="Enter Your Transaction Pin *" required="required" :type="type" />
                        <div class="show-hide" @click="showPin"><span :class="type === 'password' ? 'show' : 'hide'"></span></div>
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col-sm-12">
                        <button type="button" @click="updateEmail" class="btn btn-round btn-primary mr-1">
                        <div v-if="loadingUpdate">
                          <i class='fa fa-refresh fa-spin'></i>&nbsp;Please wait...
                        </div>
                        <div v-else>
                          Update<i class="fa fa-pencil ml-2"></i>
                        </div>
                        </button>
                        <button type="button" data-dismiss="modal" id="updateEmail" @click="resetForm" class="btn btn-outline-danger">Cancel</button>
                    </div>
                  </div>
              </div>
            </div>
        </div>
    </div>
    <!-- modal for phone number update -->
    <div class="modal fade" id="updatePhoneNumber" tabindex="-1" role="dialog" aria-labelledby="updatePhoneNumberCenter" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-centered modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title pl-2" id="updatePhoneNumberCenter" style="font-size: 18px">Change Phone Number</h5>
                    <button class="close text-dark" @click="resetForm" type="button" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body p-4">
                  <div class="mb-3 row">
                      <label class="col-sm-12 col-form-label" for="location">Phone Number <span class="text-danger">*</span></label>
                      <div class="col-sm-12 col-xl-12">
                        <input class="form-control" @paste.prevent @keypress="isNumber" maxlength="11" v-model="form.phoneNumber" placeholder="Enter New Phone Number *" type="text"/>
                      </div>
                  </div>
                  <div class="mb-3 row">
                      <label class="col-sm-12 col-form-label" for="SecurityQuestion">Security Question<span class="text-danger">*</span></label>                             
                      <div class="col-sm-12 col-md-12">
                        <select class="form-control" @change="getSecurityId" placeholder="Select" v-model="form.securityQuestionId" id="SecurityQuestion" name="SecurityQuestion" required>
                            <option value="" disabled>Select Security Question</option>
                            <option v-for="(question, index) in userSecurityQuestion" :value="question.id" :key="index">{{question.question}}</option>
                        </select>
                      </div>
                  </div>
                  <div class="row">
                      <label class="col-sm-12 col-form-label" for="SecurityAnswer">Security Answer <b class="text-danger">*</b></label>
                      <div class="col-sm-12 col-md-12">
                          <input class="form-control" v-model="form.securityAnswer" maxlength="250" name="SecurityAnswer" placeholder="Enter Security Answer *" :type="answerType" />
                          <span @click="showAnswer" class="pull-right show-Password">{{ answerType === 'password' ? 'show' : 'hide'}}</span>
                      </div>
                  </div>
                  <div class="mb-3 row">
                    <label class="col-sm-12 col-form-label" for="Token">Transaction Pin <span class="text-danger">*</span></label>
                    <div class="col-sm-12 col-xl-12">
                        <input @keypress="isNumber" @paste.prevent class="form-control" min="0" v-model="form.transactionPin" pattern="\d*" maxlength="4"  placeholder="Enter Your Transaction Pin *" required="required" :type="type" value="" />
                        <div class="show-hide" @click="showPin"><span :class="type === 'password' ? 'show' : 'hide'"></span></div>
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col-sm-12">
                        <button type="button" @click="updatePhoneNumber" class="btn btn-round btn-primary mr-1">
                        <div v-if="loadingUpdate">
                          <i class='fa fa-refresh fa-spin'></i>&nbsp;Please wait...
                        </div>
                        <div v-else>
                          Update<i class="fa fa-pencil ml-2"></i>
                        </div>
                        </button>
                        <button type="button" data-dismiss="modal" id="updatePhoneNumber" @click="resetForm" class="btn btn-outline-danger">Cancel</button>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
    <!-- modal for address update -->
    <div class="modal fade" id="updateAddress" tabindex="-1" role="dialog" aria-labelledby="updateAddressCenter" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-centered modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title pl-2" id="updateAddressCenter" style="font-size: 18px">Change Address</h5>
                    <button class="close text-dark" @click="resetForm" type="button" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body p-4">
                  <div class="row mb-2">
                    <label class="col-sm-12 col-form-label" for="reason">Address <span class="text-danger">*</span></label>
                        <div class="col-sm-12 col-xl-12">
                            <input class="form-control" v-model="form.addressLine1" placeholder="Enter Address" type="text" maxlength="60"/>
                        </div>
                  </div>
                  <div class="row mb-2">
                      <label class="col-sm-12 col-form-label" for="state">State <span class="text-danger">*</span></label>
                      <div class="col-sm-12 col-xl-12">
                        <select class="form-control" placeholder="Select your state" v-model="form.state">
                            <option value="" disabled>Select your state</option>
                            <option v-for="state in states" :value="state.id" :key="state.id">{{state.name}}</option>
                        </select>
                      </div>
                  </div>
                  <div class="mb-2 row">
                    <label class="col-sm-12 col-form-label" for="reason">City <span class="text-danger">*</span></label>
                        <div class="col-sm-12 col-xl-12">
                            <input class="form-control" v-model="form.city" placeholder="Enter City" type="text" />
                        </div>
                  </div>
                  <div class="mb-3 row">
                    <label class="col-sm-12 col-form-label" for="utilitybill">Utility Bill <span class="text-danger">*</span></label>                             
                    <div class="col-sm-12 col-xl-12">
                      <div class="file-upload">
                            <label for="utilityBill" class="file-upload__label"><i class='icon-file'></i></label>
                            <input
                                id="utilityBill" 
                                class="file-upload__input"
                                ref="image"
                                type="file"
                                name="file-upload"
                                accept="image/*"
                                @change="setUtilityBill"
                            />
                            <p v-if="utlityMessage" class="text-center" style="color: #E41613;"> Uploading Utility Bill Please wait...</p>
                            <div class="mt-2 d-flex justify-content-center" v-if="utilityBillSuccess">
                                <feather style="color: #4BB543;" class="mr-1" type="check"></feather>
                                <p style="color: #4BB543;"> Utility Bill uploaded successfully</p>
                            </div>
                        </div>
                      </div>
                  </div>
                  <div class="mb-2 row">
                      <label class="col-sm-12 col-form-label" for="SecurityQuestion">Security Question<span class="text-danger">*</span></label>                             
                      <div class="col-sm-12 col-md-12">
                        <select class="form-control" @change="getSecurityId" placeholder="Select" v-model="form.securityQuestionId" id="SecurityQuestion" name="SecurityQuestion" required>
                            <option value="" disabled>Select Security Question</option>
                            <option v-for="(question, index) in userSecurityQuestion" :value="question.id" :key="index">{{question.question}}</option>
                        </select>
                      </div>
                  </div>
                  <div class="row">
                      <label class="col-sm-12 col-form-label" for="SecurityAnswer">Security Answer <b class="text-danger">*</b></label>
                      <div class="col-sm-12 col-md-12">
                          <input class="form-control" v-model="form.securityAnswer" maxlength="250" name="SecurityAnswer" placeholder="Enter Security Answer *" :type="answerType" />
                          <span @click="showAnswer" class="pull-right show-Password">{{ answerType === 'password' ? 'show' : 'hide'}}</span>
                      </div>
                  </div>
                  <div class="mb-3 row">
                    <label class="col-sm-12 col-form-label" for="Token">Transaction Pin <span class="text-danger">*</span></label>
                    <div class="col-sm-12 col-xl-12">
                        <input @keypress="isNumber" @paste.prevent class="form-control" min="0" v-model="form.transactionPin" pattern="\d*" maxlength="4"  placeholder="Enter Your Transaction Pin *" required="required" :type="type" value="" />
                        <div class="show-hide" @click="showPin"><span :class="type === 'password' ? 'show' : 'hide'"></span></div>
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col-sm-12">
                        <button type="button" @click="updateAddress" class="btn btn-round btn-primary mr-1">
                        <div v-if="loadingUpdate">
                          <i class='fa fa-refresh fa-spin'></i>&nbsp;Please wait...
                        </div>
                        <div v-else>
                          Update<i class="fa fa-pencil ml-2"></i>
                        </div>
                        </button>
                        <button type="button" data-dismiss="modal" id="updateAddress" @click="resetForm" class="btn btn-outline-danger">Cancel</button>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
  </div>
  <div v-else class="loader-12"></div>
</div>
</template>
<script>
  import { decrypt } from '@/_services/encryption';
  import { mapState } from 'vuex';
  import $ from 'jquery';
  export default {
    components: {
    },
    data:() => ({
      form: {
        accountNumber: '',
        phoneNumber: '',
        address: '',
        email: '',
        transactionPin: '',
        securityQuestionId: '',
        securityAnswer: '',
        addressLine1: '',
        city: '',
        state: '',
        platform: 1,
        type: 1,
        file: null,
      },
      imgsrc: '',
      utilityBillSuccess: false,
      utlityMessage: false,
      step: 1,
      loading: false,
      loadingImage: false,
      loadingUpdate: false,
      type: 'password',
      answerType: 'password',
      userImage: require('@/assets/TAJimages/user/user.png'),
      isSecurityQuestion: localStorage.getItem('isSecurityQuestion'),
    }),
    computed: {
      ...mapState({
        details: state => state.dashboard.dashboardData,
        // eslint-disable-next-line no-confusing-arrow
        userAccounts: state => state.dashboard.dashboardData ? state.dashboard.dashboardData.accounts : [],
        userSecurityQuestion: state => state.authentication.userSecurityQuestion,
        // eslint-disable-next-line no-confusing-arrow
        states: state => state.authentication ? state.authentication.states : null,
        // eslint-disable-next-line no-confusing-arrow
        profilePicture: state => state.dashboard ? state.dashboard.profilePicture : null,
      }),
      userEmail() {
        return this.details ? this.details.customerDetails.email : null;
      },
      userName() {
        return this.details ? this.details.customerDetails.userName : null;
      },
      userPhoneNumber(){
        return this.details ? this.details.customerDetails.phoneNumber1 : null;
      },
      userAddress() {
        return this.details ? this.details.customerDetails.addressLine1 : null;
      },
    },
    async mounted() {
      if(this.isSecurityQuestion === 'true') {
        this.$router.push('/settings/reset-security-question');
      }
      this.$store.dispatch('dashboard/getDashboardData').then(response => {
        if(response.status === 200) {
          this.$store.dispatch('getUserSecurityQuestion', { username: this.userName, customerType: 2 });
          this.$store.dispatch('dashboard/getProfilePicture', { username: this.userName });
          this.$store.dispatch('getStates');
        }
      });
    },
    methods : {
      isNumber(event) {
        // prevent user to enter non-numeric value
        if (event.keyCode < 48 || event.keyCode > 57) {
          event.returnValue = false;
        }
      },
      showAnswer() {
        this.answerType = this.answerType === 'password' ? 'text' : 'password';
      },
      showPin() {
        this.type = this.type === 'password' ? 'text' : 'password';
      },
      getSecurityId(event) {
        this.form.securityQuestionId = event.target.value;
      },
      clearObject(array, key, value) {
        array.forEach((item, index) => {
          if (item[key] === value) {
            array.splice(index, 1);
          }
        });
      },
      uploadImage(event) {
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append('file', file);
        this.loadingImage = true;
        this.$store.dispatch('dashboard/uploadImage', formData).then(() => {
          let reader = new FileReader();
          reader.onload = e => {
            const image = e.target.result.replace('data:', '').replace(/^.+,/, '');
            this.$store.commit('dashboard/SET_PROFILE_PICTURE', image);
          };
          reader.readAsDataURL(file);
          this.loadingImage = false;
        }).catch(error => {
          this.loadingImage = false;
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.$swal({
            title: 'Oops...',
            text: objError.errors[0],
            type: 'error',
            confirmButtonText: 'Ok'
          });
        });
      },
      setUtilityBill(event) {
        this.utilityBillSuccess = true;
        // this.form.file = event.target.files[0];
        const input = event.target;
        if (input.files) {
          const reader = new FileReader();
          reader.onload = (e) => {
            const fileData = e.target.result;
            this.form.file = fileData;
            this.utilityBillSuccess = true;
          };
          reader.readAsDataURL(input.files[0]);
        }
      },
      updateEmail() {
        if(this.form.email === '' || this.form.securityQuestionId === '' || this.form.securityAnswer === '' || this.form.transactionPin === '') {
          this.$swal({
            type: 'error',
            title: 'Oops...',
            text: 'Please fill all the required fields',
          });
        } else {
          const formData = new FormData();
          formData.append('type', 1);
          formData.append('email', this.form.email);
          formData.append('securityQuestionId', this.form.securityQuestionId);
          formData.append('securityAnswer', this.form.securityAnswer);
          formData.append('transactionPin', this.form.transactionPin);
          formData.append('platform', this.form.platform);
          this.loadingUpdate = true;
          this.$store.dispatch('requests/accountUpdate', formData).then(response => {
            if(response.status === 200) {
              this.loadingUpdate = false;
              this.resetForm();
              $('#updateEmail').modal('hide');
              this.step++;
            }
          }).catch(error => {
            this.loadingUpdate = false;
            const decryptedError = decrypt(error.response.data);
            const objError = JSON.parse(decryptedError);
            this.$swal({
              title: 'Oops...',
              text: objError.errors[0],
              type: 'error',
              confirmButtonText: 'Ok'
            });
          });
        }
      },
      updatePhoneNumber() {
        if(this.form.phoneNumber === '' || this.form.securityQuestionId === '' || this.form.securityAnswer === '' || this.form.transactionPin === '') {
          this.$swal({
            type: 'error',
            title: 'Oops...',
            text: 'Please fill all the required fields',
          });
          return;
        } if(this.form.phoneNumber.length < 11 ) {
          this.$swal({
            type: 'error',
            title: 'Oops...',
            text: 'Phone number should not be less than 11 digits',
          });
          return;
        } else {
          const formData = new FormData();
          formData.append('type', 2);
          formData.append('phoneNumber', this.form.phoneNumber);
          formData.append('securityQuestionId', this.form.securityQuestionId);
          formData.append('securityAnswer', this.form.securityAnswer);
          formData.append('transactionPin', this.form.transactionPin);
          formData.append('platform', this.form.platform);
          this.loadingUpdate = true;
          this.$store.dispatch('requests/accountUpdate', formData).then((response) => {
            if(response.status === 200) {
              this.loadingUpdate = false;
              this.resetForm();
              $('#updatePhoneNumber').modal('hide');
              this.step++;
            }
          }).catch(error => {
            this.loadingUpdate = false;
            const decryptedError = decrypt(error.response.data);
            const objError = JSON.parse(decryptedError);
            this.$swal({
              title: 'Oops...',
              text: objError.errors[0],
              type: 'error',
              confirmButtonText: 'Ok'
            });
          });
        }
      },
      // convert dataURI to blob
      dataURItoBlob(dataURI) {
        const byteString = atob(dataURI.split(',')[1]);
        const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
      },
      // convert dataURI to file
      dataURItoFile(dataURI, filename) {
        const blob = this.dataURItoBlob(dataURI);
        const file = new File([blob], filename, { type: 'image/jpg' });
        return file;
      },
      updateAddress() {
        if(this.form.addressLine1 === '' || this.form.city === '' || this.form.state === '' || this.form.file === '' || this.form.securityQuestionId === '' || this.form.securityAnswer === '' || this.form.transactionPin === '') {
          this.$swal({
            type: 'error',
            title: 'Oops...',
            text: 'Please fill all the required fields',
          });
          return;
        } else {
          var blob = this.dataURItoFile(this.form.file, 'utilitybill.jpg');
          const formData = new FormData();
          formData.append('type', 4);
          formData.append('file', blob);
          formData.append('addressLine1', this.form.addressLine1);
          formData.append('state', this.form.state);
          formData.append('city', this.form.city);
          formData.append('securityQuestionId', this.form.securityQuestionId);
          formData.append('securityAnswer', this.form.securityAnswer);
          formData.append('transactionPin', this.form.transactionPin);
          formData.append('platform', this.form.platform);
          this.loadingUpdate = true;
          this.$store.dispatch('requests/accountUpdate', formData).then((response) => {
            if(response.status === 200) {
              this.loadingUpdate = false;
              this.resetForm();
              $('#updateAddress').modal('hide');
              this.step++;
            }
          }).catch(error => {
            this.loadingUpdate = false;
            const decryptedError = decrypt(error.response.data);
            const objError = JSON.parse(decryptedError);
            this.$swal({
              title: 'Oops...',
              text: objError.errors[0],
              type: 'error',
              confirmButtonText: 'Ok'
            });
          });
        }
      },
      resetForm() {
        // reset form
        this.form.accountNumber = '';
        this.form.phoneNumber = '';
        this.form.address = '';
        this.form.email = '';
        this.form.transactionPin = '';
        this.form.securityQuestionId = '';
        this.form.securityAnswer = '';
        this.form.state = '';
        this.form.city = '';
      },
    },
  };
</script>
<style scoped>
.file-content .card .card-header,
.file-content .card .card-body {
  padding: 40px !important;
}
.card .card-header h5 {
    font-size: 23px;
    font-weight: 300;
}
.btn-light {
    background-color: #e6e6e6 !important;
    color: #000000!important;
    /* border-color: rgba(228, 31, 19, 0.06) !important; */
}
.theme-form select.acct-num {
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  width: 100%;
}
.form-control {
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  width: 100%;
}
.form-select {
  width: 100%;
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  color: #898989;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem
}
.form-control::placeholder {
  color: #898989;
}
.pull-right {
  color:#E41613;
}
.btn-outline-danger {
  border-color: #e6e6e6;
  color: #000;
  margin-left: 5px;
}
.swal2-actions >>> .swal2-confirm {
  background-color: #1a803f !important;
}
.loader-12 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5) url("../../assets/TAJimages/backgrounds/taj_loader_sm.gif") center center no-repeat;
  z-index: 1000;
  border-radius: 10px;
}
.vdp-datepicker {
  width: 485px !important;
}
.file-upload {
	position: relative;
	display: inline-block;
  width: 100%;
}
 .file-upload__label {
	display: block;
	border: 3px solid #DF351712 !important;
  background-color: #DF351708 !important;
  border-radius: 10px !important;
  width: 100%;
  height: 100px;
  text-align: center;
  padding: 30px 0px;
}
 .file-upload__label:hover {
	cursor: pointer;
}
 .file-upload__input {
	position: relative;
    display: none;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	font-size: 1;
	width: 0;
	height: 100%;
	opacity: 0;
}
.file-upload__label .fa-id-card-o,
.file-upload__label .fa-user-circle-o,
.file-upload__label .icon-file {
    color: #E41613;
    font-size: 25px;
}
@media (max-width: 767px) {
  .file-upload {
    width: 100%;
  }
  .file-upload__label {
    width: 100%;
  }
}
</style>